import { inject, Injectable } from '@angular/core';

import { UserService } from 'src/app/_services/users/user.service';
import { CHAT_AI_COMPONENT_CONFIG, IChatAiComponentConfig } from 'src/app/chat-ai/models/chat-ai-config.models';
import { BotMessage, Message, MessageType } from 'src/app/chat-ai/models/chat-ai.models';

@Injectable()
export class ChatAiStorageService {
    private readonly storage: Storage = sessionStorage;
    private readonly config: IChatAiComponentConfig = inject(CHAT_AI_COMPONENT_CONFIG);
    private readonly userService: UserService = inject(UserService);

    private get messagesStorageKey(): string {
        return this.appendUserId(this.config.storageKey);
    }

    private get uuidStorageKey(): string {
        return this.appendUserId(`chat-ai-session-uuid_${this.config.storageKey}`);
    }

    public getMessages(): Message[] {
        const messagesStr: string = this.storage.getItem(this.messagesStorageKey);
        if (messagesStr?.length) {
            return JSON.parse(messagesStr);
        }

        return [];
    }

    public saveMessages(messages: Message[]): void {
        if (messages?.length > 1) {
            this.storage.setItem(
                this.messagesStorageKey,
                JSON.stringify(
                    messages
                        .filter(m => m.text?.length && m.type !== MessageType.Loading)
                        .map(m => {
                            if (m.type === MessageType.Bot) {
                                (m as BotMessage).isStreaming = false;
                            }

                            return m;
                        })
                )
            );
        }
    }

    public saveSessionUUID(uuid: string): void {
        this.storage.setItem(this.uuidStorageKey, uuid);
    }

    public getSessionUUID(): string {
        return this.storage.getItem(this.uuidStorageKey);
    }

    private appendUserId(id: string): string {
        if (this.userService.user) {
            return id.concat(this.userService.user.id.toString());
        }

        return id;
    }
}
